import { LoadingButton } from "@mui/lab"
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Link, Stack, Tooltip, Typography } from "@mui/material"
import React from "react"
import Dropzone from "react-dropzone"
import FileIcon from "../../../components/Icons/FileIcon"
import Spinner from "../../../components/Spinner"
import { dialogTypes, enrollConsentTypeLookups } from "../../../constants"
import useDialogProps from "../../../hooks/useDialogProps"
import { useEnrollConsents } from "../../../redux/entrantForm/enrollConsentSlice"
import FileDownloadButton from "../../../components/FileDownloadButton"

const EnrollConsentInfo = ({ userInfo }) => {

    const {
        isLoading, consents, isConsentNotSubmitted,
        handleAddConsent, canAddConsent,
        acceptedFiles, handleDrop, handleDeleteAcceptedFile
    } = useEnrollConsents(userInfo?.id)

    const { dialogIsOpen, openDialog, closeDialog } = useDialogProps()

    if (isLoading) return <Spinner height={251} />

    return <Box sx={{ minHeight: 251, display: "flex", flexDirection: "column" }}>

        <Box sx={{ my: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>

            <FileDownloadButton
                component="link"
                url={`operator/users/${userInfo?.id}/print_confirmation/`}
                name="Скачать шаблон"
            />

            <Typography align="center">
                {isConsentNotSubmitted ? consents?.length === 0 ? "Вы еще не подавали согласие на зачисление" : "Вы отозвали согласие на зачисление" : "Вы подали согласие на зачисление"}
            </Typography>
            <Typography
                color="primary.main"
                align="center"
                sx={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => openDialog({ dialogType: dialogTypes.ENROLL_CONSENT_HISTORY })}
            >
                История
            </Typography>
        </Box>

        <Dropzone
            onDrop={handleDrop}
            maxSize={1024 * 1024 * 5}
            accept={{
                "image/jpeg": [],
                "image/png": [],
                "application/pdf": [],
            }}
            noDragEventsBubbling
        >
            {({ getRootProps, getInputProps }) => {

                const { onClick, ...rootProps } = getRootProps()

                return <Box
                    {...rootProps}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#E8F2FF",
                        borderRadius: "5px",
                        borderColor: "primary",
                        mt: 2, mb: 2, p: 1,
                        minHeight: 120
                    }}
                >
                    <Box
                        sx={{
                            p: 1,
                            display: "flex",
                            flexWrap: "wrap",
                        }}
                    >
                        {acceptedFiles.length === 0 ? (
                            <Typography align="center" sx={{ m: 1 }}>
                                Перетащите подтверждающий документ сюда или загрузите вручную. Допустимые форматы: pdf, png и jpg, размером не более 5Мб
                            </Typography>
                        ) : acceptedFiles.map((acceptedFile, acceptedFileIndex) => <FileIcon
                            key={acceptedFileIndex}
                            name={acceptedFile.name}
                            type={acceptedFile.type}
                            onDelete={() => handleDeleteAcceptedFile(acceptedFileIndex)}
                        />)}
                    </Box>

                    <Button sx={{ height: 35 }} variant="contained" onClick={onClick}>
                        Добавить файлы
                    </Button>

                    <input {...getInputProps()} />
                </Box>
            }}
        </Dropzone>

        <Tooltip title={canAddConsent ? "" : "Для подачи согласия прикрепите скан подтвердающего документа"}><span>
            <Button
                sx={{ mt: "auto" }}
                variant="contained"
                onClick={() => handleAddConsent(isConsentNotSubmitted ? "electronic" : "not_submitted")}
                fullWidth
                disabled={isLoading || !canAddConsent}
            >
                {isConsentNotSubmitted ? "Подать согласие" : "Отозвать согласие"}
            </Button>
        </span></Tooltip>
        <Dialog open={dialogIsOpen} onClose={closeDialog} fullWidth maxWidth="sm">
            <DialogTitle>История подачи согласий</DialogTitle>
            <DialogContent>
                {consents.map(consent => <React.Fragment key={consent.id}>
                    <Typography>
                        {enrollConsentTypeLookups[consent.type]}
                    </Typography>
                    <Typography variant="subtitle2" color="grey">
                        {new Date(consent.modified_at).toLocaleString()}
                    </Typography>
                    <Stack>
                        {consent.read_files.map((file, index) => <Link
                            key={index}
                            href={file.link}
                            target="_blank"
                        >
                            {file.name}
                        </Link>)}
                    </Stack>
                    <Divider sx={{ my: 1 }} />
                </React.Fragment>)}
            </DialogContent>
            <DialogActions>
                <LoadingButton loading={isLoading} color="error" onClick={closeDialog}>Закрыть</LoadingButton>
            </DialogActions>
        </Dialog>
    </Box >
}

export default EnrollConsentInfo